var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoTelefonePerfil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16444",
    "data-name": "Grupo 16444",
    transform: "translate(-166 -1502)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_58",
    "data-name": "Elipse 58",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(166 1502)",
    fill: "#d13c8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_246",
    "data-name": "Caminho 246",
    d: "M14.9,12.459a2.588,2.588,0,0,0-1.5-.723,1.693,1.693,0,0,0-1.181.688l-.113.114a.244.244,0,0,1-.184.068c-.29,0-.914-.278-2.235-1.6C7.847,9.175,8.044,8.693,8.148,8.588l.113-.111C8.9,7.85,9.447,7.309,8.227,5.79A1.711,1.711,0,0,0,6.949,5a2.148,2.148,0,0,0-1.42.882c-.067.07-.131.138-.195.2-.442.442-.441,1.407,0,2.584a11.791,11.791,0,0,0,2.716,3.965c2.251,2.251,4.389,3.05,5.536,3.05a1.4,1.4,0,0,0,1.012-.332c.064-.063.132-.128.2-.194a2.084,2.084,0,0,0,.881-1.464A1.751,1.751,0,0,0,14.9,12.459ZM14.556,14.9c-.072.068-.142.135-.208.2a1.063,1.063,0,0,1-.758.227c-1.078,0-3.109-.771-5.282-2.945A11.435,11.435,0,0,1,5.674,8.541c-.381-1.009-.415-1.874-.085-2.2.065-.066.132-.136.2-.208.343-.361.732-.77,1.16-.77a1.413,1.413,0,0,1,1,.657c1.017,1.265.658,1.619.062,2.205l-.115.113c-.475.476.011,1.406,1.531,2.926,1.146,1.146,1.96,1.7,2.489,1.7h0a.6.6,0,0,0,.438-.173l.115-.116c.32-.325.572-.581.925-.581a2.324,2.324,0,0,1,1.279.644,1.452,1.452,0,0,1,.655.968C15.344,14.148,14.925,14.545,14.556,14.9Z",
    transform: "translate(164.654 1500.659)",
    fill: "#fafafa",
    stroke: "#fafafa",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTelefonePerfil);
export default __webpack_public_path__ + "static/media/ico-telefone-perfil.8c288dfb3d01c046c514364056579557.svg";
export { ForwardRef as ReactComponent };